import { Landscape } from '../../utils/editorReactIcons';
export { Landscape };
export default Landscape;
